import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OrderByPipe } from '@wm/components-base';
import { extractType } from '@wms/core';
import { toLower } from 'lodash-es';

import { BaseComponent } from '../base/base.component';
import { WmsToggleComponent } from '../wms-toggle/wms-toggle.component';

@Component({
  selector: 'wms-fields-list',
  standalone: true,
  templateUrl: './fields-list.component.html',
  styleUrls: ['./fields-list.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    WmsToggleComponent,
    OrderByPipe
  ],
  host: {'class': 'fields-list-container'}
})
export class FieldsListComponent extends BaseComponent implements OnInit {
  @Input() id!: string;
  @Input() level!: number;
  @Input() field!: any;
  @Input() currentStep: any;
  @Input() otherWdgts!: any;
  @Input() myWidgets!: any;
  @Input() fieldTypeWidgetTypeMap!: any;
  @Output() updateSelectAll = new EventEmitter<any>();
  @Output() onWidgetTypeChange = new EventEmitter<any>();
  @Output() updateSelectedComponent = new EventEmitter<any>();
  @Output() toggleInnerFields = new EventEmitter<any>();
 
  protected isPrism: boolean = false;
  collapsed: any = false;

  extractTypefunc = extractType;
  toLowerCase = toLower;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.isPrism = this.projectService.isPrism();
  }

  onRowSelect(field: any, type: string) {
    this.updateSelectedComponent.emit({field, type});
  }

  onColSelect(option: string, col: any, isSelected: boolean) {
    col.pcDisplay = isSelected;
    this.updateSelectAll.emit({option, col});
  }

  updateWidgetTypeChange(field: any, widgetType: any) {
    field.widget = widgetType;

    this.updateSelectedComponent.emit({field, type:'field'});
    this.onWidgetTypeChange.emit(field);
  }

  toggle(scope: any, event: Event) {
    event.stopPropagation();
    scope.collapsed = !scope.collapsed;
  }

  handleToggleClick(event: Event) {
    event.stopPropagation();
  }

}
